/* V6: menu open/close + ledger peek */
(function(){
  var burger = document.getElementById('burger');
  var overlay = document.getElementById('menuOverlay');
  var closer = document.getElementById('menuClose');
  function setOpen(open){
    overlay.classList.toggle('open', open);
    burger.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger && overlay){
    burger.addEventListener('click', function(){ setOpen(!overlay.classList.contains('open')); });
    if (closer) closer.addEventListener('click', function(){ setOpen(false); });
    overlay.querySelectorAll('nav a').forEach(function(a){
      a.addEventListener('click', function(){ setOpen(false); });
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') setOpen(false); });
  }
  document.querySelectorAll('.ledger .row').forEach(function(row){
    var peek = row.querySelector('.peek');
    if (!peek) return;
    row.addEventListener('mousemove', function(e){
      var r = row.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      peek.style.left = Math.min(r.width - 320, Math.max(20, x + 30)) + 'px';
      peek.style.top = (y - peek.offsetHeight * .5) + 'px';
    });
  });
})();

(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  },{threshold:0.16, rootMargin:'0px 0px -6% 0px'});
  document.querySelectorAll('[data-reveal]').forEach(function(el){ io.observe(el); });

  /* Header state */
  var bar = document.getElementById('topbar');

  /* Smooth parallax with lerp */
  var plx = [];
  document.querySelectorAll('[data-plx]').forEach(function(el){
    plx.push({el:el, speed:parseFloat(el.getAttribute('data-plx'))||0});
  });
  var drift = document.querySelector('[data-drift]');
  var slice = document.querySelector('.slice');
  var target = window.scrollY, current = target;

  function onScroll(){ target = window.scrollY; }
  window.addEventListener('scroll', onScroll, {passive:true});

  function frame(){
    current += (target - current) * 0.085;
    if(Math.abs(target-current) < 0.05) current = target;
    var vh = window.innerHeight;

    bar.classList.toggle('scrolled', target > 40);

    if(!reduced){
      plx.forEach(function(p){
        var r = p.el.getBoundingClientRect();
        var mid = r.top + r.height/2 - vh/2;
        p.el.style.transform = 'translate3d(0,' + (mid * p.speed).toFixed(2) + 'px,0)';
      });
      /* horizontal drift of collection cards */
      if(drift){
        var r = drift.getBoundingClientRect();
        var prog = Math.min(1, Math.max(0, 1 - (r.top - vh*0.1) / vh));
        drift.style.transform = 'translate3d(' + (-prog * Math.max(0, drift.scrollWidth - window.innerWidth + window.innerWidth*0.06)).toFixed(1) + 'px,0,0)';
      }
      /* two-greens seam shifts as you scroll through */
      if(slice){
        var sr = slice.getBoundingClientRect();
        var sp = Math.min(1, Math.max(0, (vh - sr.top) / (vh + sr.height)));
        slice.style.setProperty('--slice', (38 + sp*24).toFixed(2) + '%');
      }
      /* inner parallax for path/story/event imagery uses --plx-y on img wrappers */
      document.querySelectorAll('.split .half .ph img, .events .bg img, .story4 .im img, .hero.v2 .bg img').forEach(function(img){
        var rr = img.getBoundingClientRect();
        var m = (rr.top + rr.height/2 - vh/2) * 0.05;
        img.style.setProperty('--plx-y', m.toFixed(2) + 'px');
      });
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
(function(){
  var root = document.querySelector('[data-avant-product]');
  if (!root) return;
  var main = root.querySelector('.main-img img');
  root.querySelectorAll('.pd-gallery .thumbs button').forEach(function(button){
    button.addEventListener('click', function(){
      root.querySelectorAll('.pd-gallery .thumbs button').forEach(function(item){ item.classList.remove('on'); });
      button.classList.add('on');
      var image = button.querySelector('img');
      if (main && image) { main.src = button.dataset.fullImage || image.src; main.alt = image.alt || main.alt; }
    });
  });
  root.querySelectorAll('.pd-sizes button').forEach(function(button){
    button.addEventListener('click', function(){
      root.querySelectorAll('.pd-sizes button').forEach(function(item){ item.classList.remove('on'); });
      button.classList.add('on');
      var form = root.querySelector('#AvantProductForm');
      var variantInput = form && form.querySelector('input[name="id"]');
      var addButton = form && form.querySelector('button[type="submit"]');
      var addLabel = form && form.querySelector('[data-add-label]');
      var price = root.querySelector('.pd-info .price');
      if (variantInput && button.dataset.variantId) variantInput.value = button.dataset.variantId;
      if (price && button.dataset.variantPrice) price.textContent = button.dataset.variantPrice;
      if (addButton && button.dataset.variantAvailable) {
        var available = button.dataset.variantAvailable === 'true';
        addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
      }
    });
  });
})();
